module.exports = __webpack_public_path__ + "static/media/cluster-mockup-2.42ff0ff9.jpg";